import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import Pagination from "../Component/Pagination";
import ReactStars from "react-rating-stars-component";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  amountdistribute,
  bookinlist,
  cancelreason,
} from "../Redux/Action/BookingAction";
import { useDispatch, useSelector } from "react-redux";
import Flag from "react-flagkit";
import Contry from "../Component/Contry";
import { Button, Form, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import FirstLetterCapital from "../CustomHooks/FirstLetterCapital";
export default function EndTrip() {
  const [show, setshow] = useState(false);
  const [id, setid] = useState("");
  const [userId, setuserId] = useState("");
  const [page, setPage] = useState(1);
  const [subtotal, setSubTotal] = useState("");
  const [search, setSearch] = useState("");
  const [booking_number, setBookingnumber] = useState("");
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  
  useEffect(() => {
    setLoading(true);
    dispatch(
      bookinlist({
        search: "",
        status: "completed",
        page: 1,
        limit: 15,
      })
    ).finally(() => setLoading(false));
    dispatch(cancelreason());
  }, [dispatch]);
  const list = useSelector((state) => state.Booking.booking);

  //resasonlist
  const handleClose = () => {
    setshow(false);
    setid("");
  };

  //updatebookingcarer

  const handelsearch = () => {
    setLoading(true);
    if (search !== "") {
      dispatch(
        bookinlist({
          search: search,
          status: "completed",
          page: page,
          limit: 10,
        })
      ).finally(() => setLoading(false));
    } else {
      dispatch(
        bookinlist({
          search: "",
          status: "completed",
          page: page,
          limit: 10,
        })
      ).finally(() => setLoading(false));
    }
  };

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
    setLoading(true);
    dispatch(
      bookinlist({
        search: "",
        status: "completed",
        page: e.selected + 1,
        limit: 10,
      })
    ).finally(() => setLoading(false));
  };

  //refund
  const formik = useFormik({
    initialValues: {
      balance: "",
    },
    validationSchema: Yup.object().shape({
      balance: Yup.number()
        .required("Amount is required")
        .test(
          "is-less-than-subtotal",
          "Balance should be less than or equal to the subtotal",
          function (value) {
            return value <= subtotal; // Ensure balance is less than subtotal
          }
        ),
    }),
    onSubmit: (value, { setSubmitting, resetForm }) => {
      const payload = {
        currency: "USD",
        booking_id: id,
        userId: userId,
        booking_number: booking_number || "N/A",
        balance: String(value.balance || "0")
      };

      dispatch(amountdistribute(payload)).then(function () {
        setshow(false);
        formik.resetForm();
        setLoading(true);
        dispatch(
          bookinlist({
            search: "",
            status: "completed",
            page: 1,
            limit: 15,
          })
        ).finally(() => setLoading(false));
        setSubmitting(false);
      });
    },
  });
  return (
    <Layout>
      {/* Header */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Completed Trips</h1>
              <p className="text-gray-600 mt-1">Process payments for completed trips and manage carer earnings</p>
            </div>
            <div className="flex items-center space-x-3">
              <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                {(list?.data || []).filter(obj => obj?.carer && (obj?.carer?.first_name || obj?.carer?.last_name || obj?.carer?._id)).length} Completed
              </div>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="p-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search by booking ID..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors"
                />
                {search && (
                  <button
                    onClick={() => setSearch('')}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
            <button
              onClick={handelsearch}
              className="px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
            >
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gradient-to-r from-green-50 to-green-100 border-b border-green-200">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Booking Number</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Carer</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Contact</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Amount</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Rating</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Feedback</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Picture</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan={8} className="px-6 py-12 text-center text-gray-500">
                    <div className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-green-500 mr-2"></div>
                      Loading completed trips...
                    </div>
                  </td>
                </tr>
              ) : (list?.data || [])
                  .filter(obj => obj?.carer && (obj?.carer?.first_name || obj?.carer?.last_name || obj?.carer?._id))
                  .length === 0 ? (
                <tr>
                  <td colSpan={8} className="px-6 py-12 text-center text-gray-500">
                    <div className="flex flex-col items-center">
                      <svg className="w-12 h-12 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <p className="text-lg font-medium text-gray-900 mb-1">No completed trips</p>
                      <p className="text-gray-500">There are no completed trips requiring payment processing.</p>
                    </div>
                  </td>
                </tr>
              ) : (
                (list?.data || [])
                  .filter(obj => obj?.carer && (obj?.carer?.first_name || obj?.carer?.last_name || obj?.carer?._id))
                  .map((object, i) => (
                    <tr key={i} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="font-medium text-gray-900">#{object?.booking_number}</div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center">
                          <img
                            src={
                              object?.carer?.profile_picture ||
                              "https://i.imghippo.com/files/tE3170G.webp"
                            }
                            alt="profile"
                            className="w-10 h-10 rounded-full object-cover mr-3"
                          />
                          <div>
                            <div className="font-medium text-gray-900">
                              {object?.carer?.first_name || object?.carer?.last_name
                                ? FirstLetterCapital(
                                    `${object?.carer?.first_name || ""} ${object?.carer?.last_name || ""}`.trim()
                                  )
                                : "Deleted Carer"}
                            </div>
                            <div className="text-sm text-gray-500">{object?.carer?.email || "N/A"}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center text-sm text-gray-900">
                          {object?.carer?.phone?.country_code ? (
                            <>
                              <Flag
                                country={Contry(object?.carer?.phone?.country_code)}
                                size={16}
                                className="mr-2"
                              />
                              <span>
                                {object?.carer?.phone?.country_code} {object?.carer?.phone?.number}
                              </span>
                            </>
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="font-semibold text-green-600">
                          {object?.payment_details?.subtotal !== null
                            ? Number(object.payment_details.subtotal).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                            : "N/A"}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center">
                          <ReactStars
                            count={5}
                            size={20}
                            isHalf={true}
                            activeColor="#ffd700"
                            value={object?.review?.rating || 0}
                            edit={false}
                          />
                          <span className="ml-2 text-sm text-gray-600">
                            ({object?.review?.rating || 0})
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="max-w-xs">
                          <div 
                            className="text-sm text-gray-900 truncate cursor-help"
                            data-tooltip-id={`feedback-${i}`}
                            data-tooltip-content={object?.review?.feedback || "No feedback provided"}
                          >
                            {object?.review?.feedback || "No feedback"}
                          </div>
                          <ReactTooltip id={`feedback-${i}`} place="top" />
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        {object?.review?.picture ? (
                          <img
                            src={object?.review?.picture}
                            alt="Review"
                            className="w-10 h-10 rounded-lg object-cover cursor-pointer hover:scale-110 transition-transform"
                            onClick={() => window.open(object?.review?.picture, '_blank')}
                          />
                        ) : (
                          <span className="text-gray-400 text-sm">No image</span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() => {
                            setshow(true);
                            setid(object?._id);
                            setuserId(object.carer?._id);
                            setBookingnumber(object?.booking_number);
                            const effectiveTotal = object?.payment_details?.total_amount != null
                              ? Number(object.payment_details.total_amount)
                              : Number(object?.payment_details?.subtotal || 0);
                            setSubTotal(effectiveTotal);
                            const carerNet = object?.payment_details?.carer_payout != null
                              ? Number(object.payment_details.carer_payout).toFixed(2)
                              : (Math.round(effectiveTotal * 0.90 * 100) / 100).toFixed(2);
                            formik.setFieldValue("balance", carerNet);
                          }}
                          className="inline-flex items-center px-3 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                          data-tooltip-id={`pay-${i}`}
                          data-tooltip-content="Process payment to carer"
                        >
                          <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                          </svg>
                          Pay Now
                        </button>
                        <ReactTooltip id={`pay-${i}`} place="top" />
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>
        
        {/* Pagination */}
        {(list?.data || []).filter(obj => obj?.carer && (obj?.carer?.first_name || obj?.carer?.last_name || obj?.carer?._id)).length > 0 && (
          <div className="px-6 py-4 border-t border-gray-200">
            <Pagination
              handlePageClick={handlePageClick}
              pageCount={Math.ceil((list?.totalItems || 0) / 10)}
            />
          </div>
        )}
      </div>
        <Modal show={show} onHide={handleClose}>
          <form onSubmit={formik.handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Process Carer Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex">
                  <svg className="w-5 h-5 text-blue-400 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                  <div>
                    <h4 className="text-sm font-medium text-blue-800">Settlement Breakdown</h4>
                    <p className="text-sm text-blue-700 mt-1">
                      Platform commission (10%) is retained by the platform. Carer receives 90% net share of the total charged amount.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-3 mb-3">
                <div>
                  <Form.Label className="font-medium text-gray-700">Total Charged Amount</Form.Label>
                  <Form.Control
                    type="text"
                    value={subtotal ? Number(subtotal).toLocaleString("en-US", { style: "currency", currency: "USD" }) : ""}
                    readOnly
                    className="bg-gray-50"
                  />
                </div>
                <div>
                  <Form.Label className="font-medium text-gray-700">Platform Commission (10%)</Form.Label>
                  <Form.Control
                    type="text"
                    value={subtotal ? (Number(subtotal) * 0.10).toLocaleString("en-US", { style: "currency", currency: "USD" }) : ""}
                    readOnly
                    className="bg-gray-50 text-gray-600"
                  />
                </div>
              </div>
              
              <Form.Group controlId="carerAmount">
                <Form.Label className="font-medium text-gray-700">Carer Payment Amount (90% Net Share)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Enter amount for carer"
                  name="balance"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.balance}
                  className={formik.touched.balance && formik.errors.balance ? "border-red-300" : ""}
                />
                {formik.touched.balance && formik.submitCount > 0 && formik.errors.balance && (
                  <div className="text-red-600 text-sm mt-1">{formik.errors.balance}</div>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button
                variant="success"
                type="submit"
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {formik.isSubmitting ? "Processing..." : "Process Payment"}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
    </Layout>
  );
}
